import { render, staticRenderFns } from "./ingresosusuarios.vue?vue&type=template&id=5b827543"
import script from "./ingresosusuarios.vue?vue&type=script&lang=js"
export * from "./ingresosusuarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports